import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MyGoalContainer from "./okr/common_okr_components/myGoalContainer.component";
import { okrDetailConstants } from "../constants/okr/okrDetails.constants";
import { commentsConstants } from '../constants/comments.constants';
import GoalServices from '../services/goal.services';
import {
    isCloseKeyResultEnabled,
    resolveSavedKrStatus,
    showGoalMetricsFromTeamExpCol,
} from '../utils/okrFilterParams.util';

const appendMissingParam = (queryString, key, value) => {
    if (!value || new URLSearchParams(queryString).has(key)) {
        return queryString;
    }
    return `${queryString}${queryString.includes('?') ? '&' : '?'}${key}=${encodeURIComponent(value)}`;
};

const removeParam = (queryString, key) => {
    const params = new URLSearchParams(queryString);
    if (!params.has(key)) {
        return queryString;
    }
    params.delete(key);
    return `?${params.toString()}`;
};

class TeamsOkr extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadingTeamGoalData: true
        };
        this.GoalServices = new GoalServices();
    }

    getTeamGoalData = async () => {
        if (!this.state.isLoadingTeamGoalData) this.setState({isLoadingTeamGoalData: true});
        let queryString = window.location.search;
        let subString = 'teamView=1&teamView';
        if(queryString.includes(subString)) {
            queryString = '?teamId='+ this.props.initialData.teamId + '&teamView';
        }
        if (window.location.href.includes('/workstreams') && queryString && !queryString.includes('teamPage')) {
          queryString += '&teamPage=true';
        }
        // The workstreams URL often omits status; the server then uses the saved team
        // filter, which only initialData exposes. Send it so metricStatus can mirror it.
        // Ignore a bookmarked metricStatus while the Key Result Status filter is off.
        if (!isCloseKeyResultEnabled()) {
            queryString = removeParam(queryString, 'metricStatus');
        }
        const savedFilter = this.props.initialData?.filterSelectedData;
        queryString = appendMissingParam(queryString, 'status', savedFilter?.status);
        queryString = appendMissingParam(queryString, 'metricStatus', resolveSavedKrStatus(savedFilter?.metricStatus));
        const teamGoalData = await this.GoalServices.getTeamGoalData(queryString);
        if (teamGoalData.data && teamGoalData.data.data) {
            const newData = {...(this.props.initialData || {}), ...teamGoalData.data.data};
            newData.showGoalMetricList = showGoalMetricsFromTeamExpCol(
                newData.okrPreferences?.okrExpandCollpase?.teamExpCol
            );
            this.props.updateInitialTeamsData(newData);
            this.props.setUserData(newData);
        }
        this.setState({isLoadingTeamGoalData: false});
    };

    componentDidMount() {
        this.getTeamGoalData();
    }
    
    render() {
        if (this.state.isLoadingTeamGoalData) return null;
        const {
            okrDetails: {
                teams = [],
                teamId,
                userId
            }
        } = this.props;
        let params = {};
        const dragAndDropRoles = new Set([okrDetailConstants.ROLE_MANAGER, okrDetailConstants.ROLE_CO_MANAGER, okrDetailConstants.ROLE_TEAM_AMDIN]);
        const { role  } = teams.find(team => team.team_id === teamId) || {};
        if (teamId) {
            params.teamId = teamId;
        }
        if (userId) {
            params.userId = userId
        }
        params.teamPage = true;
        params.showBackToOrgBtn = false;
        return ( 
            <MyGoalContainer 
                type = {okrDetailConstants.PAGE_TYPE_TEAM_TAB_OKR}
                showFilter={true}
                showManagerFilter = {false}
                showHideShowOkr= {true}
                onlyShowOverDueFilter= {false}
                url= 'getTeamsOkr'
                isSortingEnable= {dragAndDropRoles.has(parseInt(role))}
                progressType= {okrDetailConstants.PROGRESS_TYPE_CIRCLE}
                showGoalName= {true}
                showTeamName= {false}
                showUserName= {false}
                pagination= {true}
                paginationLimit={15}
                showSourceName={true}
                showOkrDependencyAlignment={true}
                showALignmentButton={true}
                showTimeLineButton={true}
                data = {this.props.okrDetails}
                paramsList = {params}
            />
         );
    }
}

TeamsOkr.propTypes = {
    initialData: PropTypes.object,
    okrDetails: PropTypes.object,
    updateInitialTeamsData: PropTypes.func.isRequired,
    setUserData: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    okrDetails: state.okrDetailsReducer
});

const mapDispatchToProps = (dispatch) => ({
	updateInitialTeamsData: (data) => dispatch({type: okrDetailConstants.UPDATE_INITIAL_TEAMS_DATA, data}),
	setUserData: (data) => dispatch({type: commentsConstants.SET_USER_DATA, data})
});
  
export default connect(mapStateToProps, mapDispatchToProps)(TeamsOkr);